<template>
  <div class="page">
		<PageHeader>
			Вывод баланса
		</PageHeader>

		<!-- <div class="sub_header">
			<form class="search_form">
				<input type="text" placeholder="Поиск по транзакциям" v-model="search" />
				<button type="submit">Search</button>
			</form>
		</div> -->

		<div class="content">
			<div class="block"
				:class="getStatusCss(output.status)"
				v-for="output in outputs"
				:key="output._id">
				<div class="header">
					<div class="title" style="float: right;">{{ getStatusText(output.status) }}</div>
					<div class="title">ID: {{ output._id }}</div>
				</div>

				<div class="content">
					<div class="block-left">
						<p>Пользователь:</p>
						<p><b>id:</b> {{ output.user._id }} </p>
						<p><b>Логин:</b> {{ output.user.login }} </p>
						<p><b>Почта:</b> {{ output.user.email }} </p>
						<p><b>Баланс:</b> {{ output.user.balance }} руб. </p>
						<hr />
						<p><b>Валюта:</b> {{ output.valute.title }} </p>
						<p><b>Курс:</b> {{ output.valute.course }} {{ output.valute.key }}</p>
						<hr />
						<p><b>Формы:</b> </p>
						<ul style="margin-left: 20px">
							<li v-for="form in output.forms" :key="form.key">{{ form.title }}: {{ form.value }} {{ form.key === 'count' ? output.valute.key : '' }}</li>
						</ul>
					</div>
					<hr />
					<div class="buttons" v-if="+output.status === 0">
						<button type="button" class="ok" @click.prevent="submitOutput(output._id, 1)">Подтвердить</button>
						<button type="button" class="cancel" @click.prevent="submitOutput(output._id, 2)">Отклонить</button>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: 'Main',

	data: () => ({
		search: ''
	}),

	methods: {
		...mapActions('outputs', ['getOutputs', 'editOutput']),

		getStatusText (status) {
			switch (+status) {
				case 0:
					return 'В обработке'
				case 1:
					return 'Подтверждено'
				case 2:
					return 'Отклонено'
			}
		},

		getStatusCss (status) {
			switch (+status) {
				case 0:
					return { 'orange': true }
				case 1:
					return { 'green': true }
				case 2:
					return { 'red': true }
			}
		},

		submitOutput (_id, status) {
			this.editOutput({
				_id,
				status
			})
		}
	},

	computed: {
		...mapState('outputs', ['outputs']),
	},

	mounted () {
		this.getOutputs()
			.then(() => this.$nextTick())
	}
}
</script>

<style scoped>
.green {
	border-left: 5px solid green;
}
.orange {
	border-left: 5px solid orange;
}
.red {
	border-left: 5px solid red;
}

.content {
	overflow: hidden;
}

.block-left,
.block-right {
	float: left;
	padding: 0 5px 10px 5px;
	width: calc(100% - 11px);

}

.block-left {
	border-right: 1px solid #d9d9d9;
}

.buttons {
	margin-top: 10px;
	display: inline-block;
	width: 100%;
}

.buttons > button {
	width: 49%;
	display: inline-block;
}

.buttons > button.ok {
	background-color: green;
	color: #ffffff;
}

.buttons > button.cancel {
	background-color: red;
	color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Outputs/index.vue